import {
  SortOrder,
  type Team,
  type UserMonthlyReport,
  type UserMonthlyReportDataQuery,
  type UserMonthlyReportDataQueryVariables,
  UserMonthlyReportOrderByColumnEnum,
} from "@src/__generated__/graphql";
import { commonSearchParams } from "@src/utils/apolloHelpers";
import { OrderBy } from "@src/utils/components/sorting/OrderBy";
import { PaginationState } from "@src/utils/mobx/states/PaginationState";
import { action, computed, makeObservable, observable } from "mobx";

export class Store {
  @observable.ref userMonthlyReportTeams: Team[] = [];
  @observable.ref userMonthlyReportData: UserMonthlyReport[] = [];

  @observable period: { month: number; year: number };

  pagination = new PaginationState("userMonthlyReport");

  orderBy = new OrderBy<UserMonthlyReportOrderByColumnEnum>([
    {
      column: UserMonthlyReportOrderByColumnEnum.UserFullName,
      order: SortOrder.Asc,
    },
  ]);

  constructor() {
    makeObservable(this);
    const now = new Date();
    this.period = {
      month: now.getMonth(),
      year: now.getFullYear(),
    };
  }

  @computed get queryVariables(): UserMonthlyReportDataQueryVariables {
    return {
      ...this.pagination.asParams,
      orderBy: this.orderBy.clauses?.[0],
      month: this.period.month + 1,
      year: this.period.year,
    };
  }

  @computed get urlParams() {
    return {
      ...commonSearchParams(this),
      ...{
        month: this.period.month.toString(),
        year: this.period.year.toString(),
      },
    };
  }

  @action.bound setPeriod(value: Store["period"]) {
    this.period = value;
  }

  @action setTableData(src: UserMonthlyReportDataQuery) {
    this.userMonthlyReportTeams = src.userMonthlyReport.teams;
    this.userMonthlyReportData = src.userMonthlyReport.data;
    this.pagination.setFromPaginatorInfo(src.userMonthlyReport.paginatorInfo);
  }
}
